<template>
  <div class="content h-100">
    <b-row v-if="niches">
      <b-col col class="discover-main-content">
        <section class="w-100">
          <div class="title-container-only-text d-flex align-items-center mt-3">
            <h1 class="title">
              {{ $t(contentTitle) }}
            </h1>
          </div>
          <p class="discover-text">
            {{ $t(description) }}
          </p>
          <div v-if="listExist('home_browse_niches', getMerch)">
            <h2 class="niches-subtitle">{{ $t('discover.default.content4.subtitle') }}</h2>

            <div class="w-100 position-relative carousel-container">
              <Carousel
                :items="list('home_browse_niches', getMerch)"
                :height="150"
                :margin-right="42"
                :margin-bottom="45"
                :see-more-enabled="true"
                :border-radius="10"
                :see-more-link="$urlBuilder('niches-home')"
                :show-shadow="true"
                :show-bottom-bar="true"
                class="position-absolute w-100"
                :is-grouper="true"
              >
                <template #bottomBar="slotProps">
                  <CollectionsBottomBar :show-see-more="false" :data="slotProps.data" />
                </template>
              </Carousel>
            </div>
          </div>
        </section>
      </b-col>
    </b-row>

    <b-row v-else class="h-100">
      <b-col lg="6">
        <div v-if="onlyText" class="discover-main-content pr-2 mt-3">
          <section>
            <div class="title-container-only-text d-flex align-items-center">
              <h1 class="title">{{ $t(contentTitle) }}</h1>
            </div>
            <p class="discover-text">
              {{ $t(description) }}
            </p>
          </section>
        </div>
        <div v-else class="discover-main-content pr-2">
          <HoverSection
            :content-title="contentTitle"
            :content-items="contentItems"
            :box-width-min-content="true"
            :box-hover-background-color="boxHoverBackgroundColor"
            :box-hover-font-color="fontColor"
            :box-font-color="fontColor"
            :title-font-color="fontColor"
            :title-container-height="170"
            :icon-description-font-weight="400"
          />
        </div>
        <div class="footer-content position-absolute">
          <nuxt-link
            v-for="(item, index) in footerLinks"
            :key="index"
            :to="item.link"
            class="text"
            :style="{ color: fontColor }"
            @click.native="hideModalGaEvent(item.link)"
          >
            {{ $t(item.text) }}
          </nuxt-link>
          <div class="mt-3">
            <Button
              :shape="shape"
              :to="seeAllLink"
              :blank="!internalLink"
              :style="{ color: fontColor }"
              @click.native="clickSeeAll(seeAllLink)"
            >
              {{ $t(seeAllText) }}
            </Button>
          </div>
        </div>
      </b-col>

      <b-col lg="6">
        <div
          v-for="(o, index) in options"
          :key="index"
          class="discover-image"
          :class="`discover-image-${contentImgPosition}`"
        >
          <img v-show="optionSelected == index" :src="o.img" :alt="$t(o.title)" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HoverSection from '@/components/Common/HoverSection';
import Button from 'UI/Button';
import Carousel from '@/components/Common/Carousel';
import CollectionsBottomBar from '@/components/Collections/CollectionsBottomBar';

export default {
  name: 'DiscoverContent',
  components: {
    HoverSection,
    Button,
    Carousel,
    CollectionsBottomBar
  },
  props: {
    contentTitle: {
      type: String,
      required: true
    },
    fontColor: {
      type: String,
      required: true
    },
    boxHoverBackgroundColor: {
      type: String,
      required: false,
      default: ''
    },
    contentItems: {
      type: Array,
      required: true
    },
    footerLinks: {
      type: Array,
      required: true
    },
    seeAllLink: {
      type: String,
      required: true
    },
    seeAllText: {
      type: String,
      required: true
    },
    internalLink: {
      type: Boolean,
      required: true
    },
    contentImgPosition: {
      type: String,
      required: true
    },
    niches: {
      type: Boolean,
      required: false,
      default: false
    },
    onlyText: {
      type: Boolean,
      required: false,
      default: false
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    optionSelected: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showImage: false
    };
  },
  async fetch() {
    await this.$store.dispatch('listings/GET_LIST', {
      name: 'home_browse_niches',
      type: 'niches',
      exp: this.getMerch
    });
  },
  computed: {
    ...mapGetters('listings', ['list', 'listExist']),
    ...mapGetters('experience', ['getMerch']),
    shape() {
      return `${this.fontColor == 'white' ? 'neutral-white' : 'neutral-black'} neutral-blue-hover`;
    }
  },
  methods: {
    clickSeeAll(url) {
      this.$ga.event('Discover', 'Click Discover Block', url);
      return this.internalLink ? this.$bvModal.hide('discover-modal') : '';
    },
    hideModalGaEvent(url) {
      this.$bvModal.hide('discover-modal');
      this.$ga.event('Discover', 'Click Discover Block', url);
    }
  }
};
</script>
